const articlePaths = require("./external-docs-map.json");

const DOCS_ORIGIN = "https://docs.digifist.com";
const websiteHosts = new Set(["digifist.com", "www.digifist.com", "digifist.com.tr", "www.digifist.com.tr", "digifist.be", "www.digifist.be"]);
const themeAliases = {
  mojave: "mojave", "mojave-theme-nl-be": "mojave",
  sahara: "sahara", release: "release",
};
const themeHub = theme => `${DOCS_ORIGIN}/themes/${theme}/index`;

// The owner moved documentation to the existing Mintlify site. Only article
// paths verified against its public index and HTTP responses are mapped here.
// Unmapped legacy topics land on their real theme hub, never an invented slug.
function externalDocumentationUrl(href) {
  if (typeof href !== "string" || !href) return null;
  let parsed;
  try {
    parsed = new URL(href, "https://www.digifist.com");
  } catch {
    return null;
  }
  if (!/^https?:$/.test(parsed.protocol) || !websiteHosts.has(parsed.hostname)) return null;
  const pathname = parsed.pathname.replace(/^\/(?:en|nl-be|tr-tr)(?=\/|$)/i, "").replace(/\/+$/, "");
  if (!/^\/help-center\/documentation(?:\/|$)/i.test(pathname)) return null;
  const parts = pathname.slice("/help-center/documentation".length).split("/").filter(Boolean);
  const themePart = parts[0] === "theme" ? parts[1] : parts[0];
  const theme = themeAliases[themePart];
  const slug = parts[0] === "theme" ? parts[2] : parts[1];
  const article = theme && slug && articlePaths[`${theme}/${slug}`];
  const target = article ? `${DOCS_ORIGIN}${article}` : theme ? themeHub(theme) : `${DOCS_ORIGIN}/`;
  // Query values retain existing campaign attribution. Old fragments refer to a
  // different document structure and are deliberately not fabricated remotely.
  return `${target}${parsed.search}`;
}

function isInternalDocumentationPath(path) {
  return externalDocumentationUrl(path) !== null;
}

function externalDocumentationRedirects() {
  const routes = [];
  for (const prefix of ["", "/en", "/nl-be", "/tr-tr"]) {
    for (const [topic, destination] of Object.entries(articlePaths)) {
      routes.push({ source: `${prefix}/help-center/documentation/theme/${topic}`, destination: `${DOCS_ORIGIN}${destination}`, permanent: true, locale: false });
    }
    for (const [alias, theme] of Object.entries(themeAliases)) {
      for (const legacyPath of [`theme/${alias}`, alias]) {
        routes.push({ source: `${prefix}/help-center/documentation/${legacyPath}/:path*`, destination: themeHub(theme), permanent: true, locale: false });
      }
    }
    routes.push({ source: `${prefix}/help-center/documentation/:path*`, destination: `${DOCS_ORIGIN}/`, permanent: true, locale: false });
  }
  return routes;
}

module.exports = { DOCS_ORIGIN, articlePaths, externalDocumentationUrl, isInternalDocumentationPath, externalDocumentationRedirects };
